<span class="vox-chip" [ngClass]="{'vox-chip_royal-blue': type === ConnectivityCatalogType.modem_router,
'vox-chip_royal-blue-text': type === ConnectivityCatalogType.internet_key}">
    {{'company.connectivity.equipment-type.' + type | lowercase | translate}}
</span>